import React from 'react';
import PropTypes from 'prop-types';
import CSSTransition from '../CSSTransition';
import './style.scss';

const CircularLoader = props => (
    <div style={props.containerStyle} className="overlay-loader-container">
        <CSSTransition animation="fade-quick" className="flexbox-fill h-fill flex-center">
            <div className="circular-loader"/>
        </CSSTransition>
    </div>
);

CircularLoader.propTypes = {
    style: PropTypes.object,
    containerStyle: PropTypes.object
};
export default CircularLoader;
